import Image from 'next/image'

import { GRAFTCODE_ONBOARDING_ASSETS_BASE } from '../../graftcode-onboarding.const'
import { GRAFTCODE_ONBOARDING_TEST_IDS } from '../../graftcode-onboarding-test-ids.const'

import styles from './GraftcodeOnboardingDashboard.module.scss'

export type GraftcodeOnboardingTimelineBadgeVariant = 'done' | 'current' | 'upcoming'

type GraftcodeOnboardingTimelineBadgeProps = {
  variant: GraftcodeOnboardingTimelineBadgeVariant
}

export function GraftcodeOnboardingTimelineBadge({ variant }: GraftcodeOnboardingTimelineBadgeProps) {
  return (
    <div className={styles.timelineBadgeWrap} data-testid={GRAFTCODE_ONBOARDING_TEST_IDS.timelineBadge}>
      <div className={styles.timelineBadge} data-variant={variant} aria-hidden>
        {variant === 'done' ? (
          <Image
            className={styles.timelineCheckmark}
            src={`${GRAFTCODE_ONBOARDING_ASSETS_BASE}/timeline-checkmark.svg`}
            alt=""
            width={12}
            height={12}
          />
        ) : null}
      </div>
    </div>
  )
}
